<template>
  <div style="min-height: calc(100vh - 90px);">
    <div class="w100 bg-w search-bg" id="searchBg" v-loading="loading">
      <div class="w120 pt20 pb20 mc">
        <el-row class="w100" :gutter="10">
          <el-col class="font-18" :span="20" :offset="4">服务中心</el-col>
        </el-row>

        <el-row class="w100 mt20" :gutter="10">
          <el-col :span="20" :offset="4">
            <el-row class="w100" :gutter="10">
              <el-col :span="16">
                <div class="w100 flex-box al-c">
                  <div class="tx-r font-14">搜索名称：</div>
                  <div class="flex-1">
                    <el-input placeholder="搜索服务" clearable v-model="searchText" @keyup.enter.native="fetchSearchList()" :disabled="searching">
                      <el-button type="primary" style="background-color: #475eb7; border-color: #475eb7; color: #fff" slot="append" :loading="searching" @click="page = 1, fetchSearchList()">开始搜索</el-button>
                    </el-input>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row class="w100 mt20" :gutter="10" v-if="siftData.length > 0">
          <el-col :span="20" :offset="4" v-for="(item, index) in siftData" :key="index">
            <el-row class="w100" :gutter="10">
              <el-col :span="24">
                <div class="w100 flex-box">
                  <div class="tx-r font-14" style="line-height: 30px">{{ item.label }}：</div>
                  <div class="flex-1">
                    <ServerRadioComp ref="sift" :type-data="item" @fetch-data="page = 1, fetchSearchList()" />
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row class="w100 mt20 pt20 font-14" :gutter="10">
          <el-col class="tx-r grey" :span="4" :offset="0" style="line-height: 32px;">最近使用：</el-col>
          <el-col :span="20">
            <el-row class="w100" :gutter="10" v-if="useApp.length > 0">
              <el-col :span="6" v-for="(item, index) in useApp" :key="index">
                <div class="block w70 mb10 po-r hover search-app" @click="routerServe(item)">
                  <img :src="!item.serveImage ? baseUrl + 'images/icon-app.png' : item.serveImage">
                  <div class="w100 ellipsis-2">{{ item.serveName }}</div>
                </div>
              </el-col>
            </el-row>
            <p class="w100 font-14 grey" style="line-height: 32px;" v-else>暂无</p>
          </el-col>
        </el-row>
      </div>
    </div>

    <section class="w100" style="min-height: 100px; margin-bottom: -40px;" v-loading="searching" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="w120 po-r mc search-main" v-if="searchList.length > 0">
        <section v-for="(item, index) in searchList" :key="index" :id="item.label">
          <div class="w100 po-r search-list-title" v-if="item.serveList.length">
            <span class="in-block font-0 po-r title">
              <span class="in-block font-0 po-r sanjiao">
                <span class="font-18 white" style="line-height: 40px;">{{ item.label}}</span>
              </span>
            </span>
            <span class="ml20 grey font-14">共计 {{ item.serveList.length }} 个服务</span>
          </div>
          <el-row class="w100 mb20 pt20 pb20" :gutter="16" v-if="item.serveList.length">
            <el-col class="set20" :span="4" v-for="(val, key) in item.serveList" :key="key">
              <div >
                <div class="po-r w100 bg-ww of-h search-list">
                  <p class="po-r w100 bor-b font-14 pl10 title grey ellipsis">{{ val.serveTitle }}</p>
                  <div class="po-r w100 search-list-main" @click="routerServe(val)">
                    <img :src="!val.serveImage ? baseUrl + 'images/icon-app.png' : val.serveImage">
                    <p class="w100 ellipsis font-14">{{ val.serveName }}</p>
                    <div class="w100 star">
                      <el-rate :value="val.appraise / 2" disabled allow-half></el-rate>
                    </div>
                    <p class="w100 font-12 grey ellipsis">{{ !val.favoriteCount ? 0 : val.favoriteCount }}人收藏</p>
                  </div>
                  <div class="po-a w100 bg-w search-list-hover">
                    <!-- <div class="pt5 pb5 pl10 pr10 font-14 ellipsis-2">{{ val.serveName }}</div> -->
                    <!-- <div class="po-r w100 pl10 pr10 grey ellipsis-2">{{ !val.msg ? '简介' : val.msg }}</div> -->
                    <div class="po-a w100 tx-c white flex-box search-list-hover-btn">
                      <div class="flex-1 cu-p" style="background: #445eb5;" @click.prevent="clickCollect(val.collection, val.id, index, key)">
                        <i :class="val.collection == true ? 'el-icon-star-on' : 'el-icon-star-off'"></i> 收藏
                        <!-- {{ val.collection == true ? '取消收藏' : '点击收藏' }} -->
                      </div>
                      <div class="flex-1 cu-p" style="background: #4a66cd;" @click.prevent="clickSelfUse(val.selfUse, val.id, index, key)">
                        <i :class="val.selfUse == true ? 'el-icon-circle-check' : 'el-icon-circle-check-outline'"></i> 常用
                        <!-- {{ val.selfUse == true ? '取消常用' : '设为常用' }} -->
                      </div>
                      <div class="flex-1 cu-p" style="background: #324a9a;" v-if="val.serveType == 1" @click.prevent="goCollect(val)">评分</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </section>

        <div class="po-a fix-nav" :class="leftNavBarFix">
          <div class="cu-p fix-nav-item grey" :class="fixName == item.label ? 'yellow bold' : ''" v-for="(item, index) in searchList" :key="index" v-show="item.serveList.length" @click="goScroll(item.label)">{{ item.label }}</div>
        </div>
      </div>

      <p class="w100 tx-c mt20 pt20 pb20 font-14" v-else-if="!loading && searchList.length == 0">暂无数据</p>

      <!-- <div class="w120 mc mb20 tx-r" v-show="total > 0">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div> -->
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ServerRadioComp from "@/components/CompSift/ServerRadioComp";
import SiftComp from "@/components/CompSift/SiftComp";

export default {
  name: "server",
  components: {
    ServerRadioComp,
    SiftComp
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      error: 0,
      errorMsg: "",
      searchText: "",
      siftData: [],
      useApp: [],

      searching: false,
      page: 1,
      total: 0,
      size: 9999999,
      searchList: [],

      leftNavBarFix: "",
      fixName: ""
    };
  },
  computed: {
    
    ...mapState(["userData",'userToken']),
    idNameArr() {
      let arr = [];
      for (const item of this.searchList) {
        if (item.serveList.length) {
          arr.push(item.label);
        }
      }
      return arr;
    }
  },
  mounted() {
    this.fetchSearchData();
    this.fetchUseServe();
  },
  destroyed() {
    window.removeEventListener("scroll", this.initLeftNavBar);
  },
  methods: {
    routerServe(v){
      if(v.serveType == 2 && v.interfaceUrl) {
        // 类似正版化这些站外服务，直接打开新窗口
        const url = decodeURIComponent(v.interfaceUrl)
        window.open(url)
        return;
      }
      const route = v.serveType == 1 ? { name: `server_info`, query:{ id: v.id }} : { name: `server_search`, query:{ id: v.id, interfaceUrl: v.interfaceUrl ? v.interfaceUrl.replace(/\/| /g,'') : null }}
      this.$router.push(route)
    },
    fetchUseServe() {
      this.$http
        .post(
          "serveUse/query/latest",
          this.$qs.stringify({
            userId: this.userData.userId,
            size: 8,
            sorting: "DESC"
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resCode == 0 && data.resStatus == 0) {
            this.useApp = data.resData;
          } else {
            this.$notify({
              title: "错误",
              message: "最近使用：" + data.resMsg,
              type: "error",
              offset: 60
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.error = 404;
          this.loading = false;
        });
    },
    fetchSearchData() {
      this.loading = true;

      this.$http
        .post(
          "serve/queryCondition",
          this.$qs.stringify({
            // userId: this.userData.userId
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0 && data.resStatus == 0) {
            this.siftData = data.resData.siftData;

            this.$nextTick(() => {
              window.addEventListener("scroll", this.initLeftNavBar);
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;

          this.$nextTick(() => {
            this.fetchSearchList();
          });
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.error = 404;
          this.loading = false;
        });
    },
    goOutside(url){
        window.open(`${url}&token=${this.userToken}`)
    },
    fetchSearchList() {
      let obj = {};
      for (const i in this.siftData) {
        obj[this.siftData[i].key] = this.$refs.sift[i].value;
      }

      obj.userId = this.userData.userId;
      obj.serveKey = this.searchText;
      obj.pageNum = this.page;
      obj.pageSize = this.size;
      // console.log(obj);

      this.searching = true;

      this.$http
        .post("serve/query", this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            this.searchList = data.RetData;
            // this.total = data.resData.total;
          } else {
            this.error = 0;
            this.errorMsg = data.RetMsg;
          }
          this.searching = false;
        })
        .catch(() => {
          this.error = 404;
          this.searching = false;
        });
    },
    clickCollect(isTrue, id, index, key) {
      const URL = !isTrue ? `serveCollection/newCo` : `serveCollection/delCo`;
      this.$http
        .post(
          URL,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveId: id
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            this.searchList[index].serveList[key].collection = !isTrue;
            this.searchList[index].serveList[key].collection
              ? this.searchList[index].serveList[key].favoriteCount++
              : this.searchList[index].serveList[key].favoriteCount--;
            this.$notify({
              title: "成功",
              message: data.resMsg,
              type: "success",
              offset: 60
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
        });
    },
    clickSelfUse(isTrue, id, index, key) {
      const URL = !isTrue ? `serveUse/add` : `serveUse/cancel`;
      this.$http
        .post(
          URL,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveCode: id
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            this.searchList[index].serveList[key].selfUse = !isTrue;
            this.$notify({
              title: "成功",
              message: data.resMsg,
              type: "success",
              offset: 60
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchSearchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchSearchList();
    },
    goCollect(item) {
      // console.log(item);
      this.$router.push({
        name: "server_info",
        query: {
          id: item.id,
          showkey: "PJ",
          serveTitle: item.serveTitle
        }
      });
    },
    initLeftNavBar() {
      // console.log(
      //   document.documentElement.scrollTop >
      //     document.getElementById("searchBg").offsetHeight + 70
      // );
      const fixTop =
          document.getElementById("searchBg").offsetHeight - 20 ||
          document.getElementById("searchBg").clientHeight - 20,
        scrollTop = document.documentElement.scrollTop;
      if (scrollTop > fixTop) {
        this.leftNavBarFix = "fix-nav-fix";
      } else {
        this.leftNavBarFix = "";
      }

      let addHeight = 0 + fixTop;
      for (const item of this.idNameArr) {
        const thisDocH =
          document.getElementById(item).offsetHeight + 35 ||
          document.getElementById(item).clientHeight + 35;
        if (scrollTop >= addHeight && scrollTop < addHeight + thisDocH) {
          this.fixName = item;
          break;
        } else {
          addHeight = addHeight + thisDocH;
        }
      }
    },
    goScroll(idName) {
      // console.log(document.getElementById(idName).offsetTop);
      const fixTop =
        document.getElementById("searchBg").offsetHeight - 20 ||
        document.getElementById("searchBg").clientHeight - 20;
      window.scrollTo(0, document.getElementById(idName).offsetTop + fixTop);
      setTimeout(() => {
        this.fixName = idName;
      }, 200);
    }
  }
};
</script>

<style scoped>
.fix-nav {
  left: -40px;
  top: 0;
  font-size: 18px;
}

.fix-nav-fix {
  position: fixed;
  top: 90px;
  left: 50%;
  margin-left: -640px;
}

.fix-nav-item {
  display: block;
  margin: 20px 0;
  width: 0.5em;
  text-align: center;
  word-wrap: break-word;
  line-height: 1;
  /* color: #666; */
}

.search-list-hover {
  /* top: -100%; */
  /* top: 100%; */
  bottom: 100%;
  left: 0;
  border-radius: 8px;
  transition: top 0.2s;
  background: none;
}

.search-list-hover-btn {
  bottom: 0;
  left: 0;
  height: 35px;
  line-height: 35px;
}

.search-list:hover .search-list-hover {
  bottom: 0;
}

.search-bg {
  box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.2);
}

.search-app {
  display: flex;
  padding: 0 10px 0 70px;
  height: 60px;
  align-items: center;
}

.search-app img {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 50px;
  height: 50px;
}

.search-main {
  padding: 40px 20px 20px 39px;
  border-left: 1px solid #ccc;
}

.search-list-title .title {
  padding: 0 15px;
  height: 40px;
}

.search-list-title .title::before {
  content: "";
  display: block;
  position: absolute;
  left: -51px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
  background: #7085d7;
}

.search-list-title .title::after {
  content: "";
  display: block;
  position: absolute;
  left: -29px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 29px;
  height: 1px;
  background: #7085d7;
}

.search-list-title .sanjiao {
  padding: 0 16px;
  background: #7085d7;
}

.search-list-title .sanjiao::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: -40px;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-right: 20px solid #7085d7;
}

.search-list-title .sanjiao::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: -40px;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-left: 20px solid #7085d7;
}

.set20 {
  width: 20%;
}

.search-list {
  margin: 8px 0;
  height: 128px;
  border-radius: 8px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12);
}

.search-list .title {
  padding-right: 30px;
  height: 30px;
  line-height: 30px;
}

.search-list .title::after {
  content: "";
  display: block;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 14px;
  height: 14px;
  background: #eeeeee;
  border-radius: 50%;
}

.search-list-main {
  padding: 20px 10px 10px 80px;
  cursor: pointer;
}

.search-list-main img {
  position: absolute;
  width: 54px;
  height: 54px;
  left: 14px;
  top: 22px;
}
</style>

<style>
.search-list-main .star i {
  margin-right: 2px;
  font-size: 14px;
}

.server-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #475eb7;
  border-color: #475eb7;
}
</style>
